export default __webpack_public_path__ + "static/10-most-instagrammable-places-on-earth-peru-153fb04e721f798acf22d3433b4459b6.jpg";